<template>
    <div v-if="getPermission.ccic.view">  


     <yard-export-form ref="CreateIngate" mode="Booking"/>
    <yard-export-form ref="Instruction" mode="Instruction"/>

    <dispatch-form ref="DispatchForm" mode="YY" action = "CREATE"/>
    <dispatch-form ref="DispatchFormCopy" mode="YY" action = "COPY"/>
    <dispatch-form ref="DispatchFormChange" mode="YY" action = "CHANGE"/>


    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBox">
              <auto-complete-master-data-select
                          label="Sales Office"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_SALEOFFICE')"
                          :init-value-id="searchRequest.salesOffice"
                          :on-item-changed="handleOfficeChanged">
              </auto-complete-master-data-select>


            </div>

            <div class = "inputBox">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Pick up Location</label>
                <md-input v-model="searchRequest.pickupLocation"/>
              </md-field>
            </div>


            <div class = "inputBox">
              <md-field>
                <label>Customer Order</label>
                <md-input v-model="searchRequest.customerOrder"/>
              </md-field>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
            <div class = "inputBox">
              <md-field>
                <label>Chassis #</label>
                <md-input v-model="searchRequest.chassisNo"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Booking #</label>
                <md-input v-model="searchRequest.bookingNo" />
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Destination</label>
                <md-input v-model="searchRequest.destination" />
              </md-field>
            </div>

            <div class = "inputBox">
              <auto-complete-master-data-multiple-select
                  label="Status"
                  :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                  v-model="searchRequest.loadStatus"
              />
            </div>



          </div>
          <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">

            <div class = "inputBox">
              <md-field>
                <label>Appointment</label>
                <md-input v-model="searchRequest.appointment"/>
              </md-field>
            </div>

            <div class = "inputBox">
            <auto-complete-master-data-select
                                                :prepared-options="drivers"
                                                label="Driver"
                                                :init-value="searchRequest.driver"
                                                :on-item-changed="handleDriverRequestChanged"
                                                >
            </auto-complete-master-data-select>

            </div>

            <div class = "inputBox" > 
              <auto-complete-master-data-select
                          label="In/Out"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_STAGE_TYPE')"
                          :init-value-id="searchRequest.type"
                          :on-item-changed="handleTypeChanged">
              </auto-complete-master-data-select>

            </div>



            <div class = "inputBox">
              <md-field>
                <label>Cost Relevant</label>
                <md-input v-model="searchRequest.costRelevant" />
              </md-field>
            </div>


          </div>

          <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
              <div class = "inputBox">
              <md-field>
                <label>GST DO</label>
                <md-input v-model="searchRequest.deliveryOrder"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <auto-complete-master-data-select
                          label="Carrier Name"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_CARRIER')"
                          :init-value-id="searchRequest.carrier"
                          :on-item-changed="handleCarrierChanged">
              </auto-complete-master-data-select>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.apptDate.startDate" >
                <label>Appt. Date</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.pickupDate.startDate">
                <label>Pickup Date</label>
              </datepicker>
            </div>

          </div>


          <div  v-if="active" class="md-layout-item md-size-20 md-small-size-100">
              <div class = "inputBox">
              <md-field>
                <label>Freight Type</label>
                <md-input v-model="searchRequest.freightType"/>
              </md-field>
            </div>

            <div class = "inputBox">
              <md-field>
                <label>Group</label>
                <md-input v-model="searchRequest.group"/>
              </md-field>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.apptDate.endDate">
                <label>To</label>
              </datepicker>
            </div>

            <div class = "inputBox" >
              <datepicker v-model="searchRequest.pickupDate.endDate">
                <label>To</label>
              </datepicker>
            </div>

          </div>

          <div v-if="getPermission.ccic.edit" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/users','/api/w/gst/updateyardstage','/api/w/excel/generate', '/api/w/gst/createyardstage','/api/w/gst/createyardstage/WebCopyDeleteStage','/api/w/gst/WebYardGroupOutGate','/api/w/ccic/photo/get','/api/w/DOs/WebAssignDoHeaderWithStage', '/api/w/DOs/getdoheader']">
              <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">
               <!--<md-button class="md-raised" :disabled="!canNew" @click="doNew">New</md-button>-->
               <md-button class="md-raised custButton " :disabled="!canEditSingle" @click="CreateIngate" ><span class="icons-center material-icons">create</span> IN GATE</md-button>
               <md-button class="md-raised custButton"  :disabled="!canOutGate" @click="doOutGate" ><span class="icons-center material-icons">update</span>Out Gate</md-button>
               <md-button class="md-raised custButton " :disabled="!canEditSingle" @click="doChange" ><span class="icons-center material-icons">create</span> Change</md-button>
               <md-button class="md-raised custButton " :disabled="!canEditSingle" @click="doCopy" ><span class="icons-center material-icons">file_copy</span> Copy</md-button>
               <md-button class="md-raised custButton" :disabled="!canSave" @click="doSave"><span class="icons-center material-icons">update</span>Save</md-button>
               <md-button class="md-raised custButton"  :disabled="!noGates" @click="doEdit"><span class="icons-center material-icons">file_copy</span>Edit</md-button>
               <!-- <md-button class="md-raised custButton"  :disabled="!canEdit" @click="doCopy"><span class="icons-center material-icons">file_copy</span>Stage</md-button> -->
               <md-button class="md-raised custButton" :disabled="!canDeleteBooking" @click="doDeleteBooking"><span class="icons-center material-icons">delete</span>Booking</md-button>
               <md-button class="md-raised custButton" :disabled="!canDelete" @click="doDeleteStage"><span class="icons-center material-icons">delete</span>Stage</md-button>
               <md-button class="md-raised custButton"  :disabled="!canDeleteLoad" @click="doDeleteLoad"><span class="icons-center material-icons">delete</span>Load</md-button>
               <md-button class="md-raised custButton" :disabled="!canEdit" @click="doCockPit" ><span class="icons-center material-icons"  >create</span>CockPit</md-button>
               <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised">Search</md-button>
               <md-button   @click="doClear" class="md-raised custButton">Clear</md-button>
             <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"

                    />
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container ">
            <div class="inner-container table-wrapper ">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                    <th class="header-cell center w5" v-on:click="sortFunction('salesOffice')">Sales Office</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('loadStatus')">Load Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stageStatus')">Stage Status</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('containerNo')">Container</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('chassisNo')">Chassis</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('locationNumber')">Yard Loc.</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stage')">Stage #</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stageType')">IN/OUT</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('bookingNo')">Booking #</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">Cust Order(IBD)</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CTN Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('cutLFD')">Cargo Cut-off Date</th>
                    <th class="header-cell center w8" v-on:click="sortFunction('apptDate')">Appt Date</th>
                    <th class="header-cell center w5" >Appt Time</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('appointment')">Appointment</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('driverId')">Driver</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('truckId')">Truck ID</th>
                    <th class="header-cell center w15" v-on:click="sortFunction('pickupLocationCode')">Pickup Location Code</th>
                    <th class="header-cell center w10" >Pickup Location Name</th>
                    <th class="header-cell center w15" v-on:click="sortFunction('deliverLocationCode')">Destionation Code</th>
                    <th class="header-cell center w10" >Destionation Name</th>
                    <th class="header-cell center w10" >Instruction</th>
                    <th class="header-cell center w5" >Cost Relevant</th>
                    <th class="header-cell center w5" >Street Turn</th>
                    <th class="header-cell center w5" >Freight Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">CHZ start date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickupDate')">Pickup Date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('deliveryOrder')">GST DO</th>
                    <th class="header-cell center w5" >GST DO Item</th>
                    <th class="header-cell center w5" >Reference #</th>
                    <th class="header-cell center w5" >Route #</th>
                    <th class="header-cell center w10" >Route Desc</th>
                    <th class="header-cell center w8" >Create Person</th>
                    <th class="header-cell center w8" >Create Date</th>
                    <th class="header-cell center w8" >Update Person</th>
                    <th class="header-cell center w8" >Update Date</th>
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                     <td class="body-cell w2 ">
                      <md-checkbox v-model="item.selected">
                        <span v-if="hasBeenChanged(item)">*</span>
                      </md-checkbox>
                    </td>
                    <td class="body-cell excelBox w5">{{item.salesOffice}}</td>
                    <td class="body-cell excelBox w5">{{item.loadStatus}}</td>
                    <td class="body-cell excelBox w5">{{item.stageStatus}}</td>
                    <td class="body-cell excelBox w5">{{item.seqNo}}</td>
                    <td class="body-cell excelBox w8" @click="togeditHideeContainerCopy(item.containerNo)">{{item.containerNo}}
                      <span v-if="containerCopy == true" class="popuptext" id="myPopup">Container No copied</span></td>
                    <td class="body-cell excelBox w8" @click="toggleContainerCopy(item.chassisNo)"><div class = "spaceLine">{{item.chassisNo}}</div>
                     <!-- <div>{{getChassisUsedDate(item.chzStartDate)}} Days</div> -->
                      <span v-if="containerCopy == true" class="popuptext" id="myPopup">Chassis No copied</span></td>
                    <td  class="body-cell excelBox w5">{{item.carrier}}</td>
                    <td  class="body-cell excelBox w5"><div class = "spaceLine">{{item.yard}}</div><div>{{item.locationNumber}}</div></td>
                    <td  class="body-cell excelBox w5">{{item.stage}}</td>
                    <td  class="body-cell excelBox w5">{{item.stageType}}</td>
                    <td  class="body-cell excelBox w5">{{item.bookingNo}}</td>
                    <td  class="body-cell excelBox w5">{{item.customerOrder}}</td>
                    <td  class="body-cell excelBox w5">{{item.ctnrType}}</td>
                    <td  class="body-cell excelBox w5">{{item.cutLFD}}</td>
                    <!-- <td  class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                    <td  class="body-cell excelBox w5">{{item.deliveryTo}}</td> -->
                    <td class="body-cell excelBox w8">
                      <template v-if="!item.editing">
                        {{item.apptDate | date}}
                      </template>
                      <template v-else>
                        <div style="min-width:160px">
                        <datepicker v-model="item.apptDate">
                      </datepicker>
                        </div>
                      </template>
                      </td>
                    <td class="body-cell excelBox w5">{{item.apptDate | time}}</td>
                    <td class="body-cell excelBoxTB w5">
                      <template v-if="!item.editing">
                        {{item.appointment}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.appointment"/>
                      </md-field>
                      </template>
                      
                      </td>
                    <td class="body-cell excelBox w10">
                       <template v-if="!item.editing">
                        <template v-if="item.driverId">{{ getDriverName(item.driverId)}}({{item.driverId}})</template>
                        <template v-else>{{item.driverId}}</template>
                      </template>
                      <template v-else>
                        <div style="min-width:160px" v-if="drivers">
                          <auto-complete-master-data-select
                                  display-type="idOnly"
                                  :prepared-options="drivers"
                                  :init-value-id="item.driverId"
                                  :on-item-changed="handleDriverChanged(item)">
                          </auto-complete-master-data-select>
                        </div>
                      </template>
                      </td>
                    <td class="body-cell excelBox w5">{{item.truckId}}</td>
                    <td class="body-cell excelBox w15">
                      <autocomplete-ccic-location-select
                          v-if="item.editing"
                          v-model="item.pickupLocationCode"
                          group="GST_LOCATION"
                          :on-item-selected="handlePickLocationChanged(item)"
                      />
                      <template v-else>{{item.pickupLocationCode}}</template>
                      </td>
                      <td class="body-cell excelBox w10">
                        <master-data-display group="GST_LOCATION" :tag-id="item.pickupLocationCode"/>
                      </td>
                    <td class="body-cell excelBox w15">
                      <autocomplete-ccic-location-select
                          v-if="item.editing"
                          v-model="item.deliverLocationCode"
                          group="GST_LOCATION"
                          :on-item-selected="handleDeliverLocationChanged(item)"
                      />
                      <template v-else>{{item.deliverLocationCode}}</template></td>
                      <td class="body-cell excelBox w10">
                        <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                      </td>
                    <td class="body-cell excelBox w10" @click="toggleInstruction(item)">
                        {{item.dispatcherInstruction}}
             
                      
                      </td>
                    <td class="body-cell excelBox w5">
                      <template v-if="!item.editing">
                        {{item.costRelevant}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.costRelevant"/>
                      </md-field>
                      </template>
                      
                      </td>
                    <td class="body-cell excelBox w5">{{item.source}}</td>
                    <td class="body-cell excelBox w5">
                      <template v-if="!item.editing">
                        {{item.freightType}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.freightType"/>
                      </md-field>
                      </template>
                      
                      </td>
                    <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.pickupDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                    <td class="body-cell excelBox w5">{{item.deliveryOrderItem}}</td>
                    <td class="body-cell excelBox w5">{{item.customerRef}}</td>
                    <td class="body-cell excelBox w5"> {{item.route}}</td>
                     <td class="body-cell excelBox w10"> {{item.routeDesc}}</td>
                     <td class="body-cell excelBox w8">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w8">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w8">{{item.updatedBy}}</td>
                    <td class="body-cell excelBox w8">{{item.updatedAt | date}}</td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>





</template>


<style scoped>
.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spaceLine {
  margin-bottom: 10px;
}

.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}

.excelBox {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}



.excelBoxTB {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-right: 5px;
  
}

.excelBoxLeft {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
      
}



.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 90px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
   
}

.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
   
}

.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}



</style>



<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';
  import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import MoveCcicContainerForm from "../components/MoveCcicContainerForm.vue";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import YardExportForm from '../components/YardExportForm.vue';
  import DispatchForm from '../components/DispatchForm.vue';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


const getInitSearch = () => ({
    users: [],
    teams: [],
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driver: null,
    type: null,
    costRelevant: null,
    freightType: null,
    chzStartDate: {
      startDate: null,
      endDate: null,
    },

    apptDate: {
      startDate: null,
      endDate: null,
    },
    pickupDate: {
      startDate: null,
      endDate: null,
    },


    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    yard: null,
    locationNumber: null,
    customerOrder: null,
    deliveryOrder: null,
    route: null,
    locCode:null,
    group:null,
    locName: null,
    loadStatus: ['LD', 'JO'],
    selected: false,
  });







  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      active: false,
      drivers: [],
      items: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      active: false,
      sortStatus: true,
      filter: "",
      containerCopy: false,
    }),


    components: {
      AutocompleteCcicLocationSelect,
      MoveCcicContainerForm,
      UpdateCcicContainerStatusForm,
      CcicPhotoForm,
      callingApiCenter,
      YardExportForm,
      DispatchForm,
      
  
    },

    watch: {
      getYardExportList(val) {
        this.updateItems(val);

      },
      // eslint-disable-next-line
      "searchRequest.teams"() {
         this.searchRequest.users = [];
      },
  
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getYardExportList',
      ]),


      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.containerNo).includes(term) ||
                 this.includeNull(row.chassisNo).includes(term) ||
                //  this.includeNull(row.loadKey).includes(term)||
                 this.includeNull(row.seqNo).includes(term)||
                 this.includeNull(row.loadStatus).includes(term)||
                 this.includeNull(row.stageStatus).includes(term)||
                 this.includeNull(row.stageType).includes(term)||
                 this.includeNull(row.bookingNo).includes(term);
        })
      },



      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canOutGate(){
        return this.getSelectedItems.length != 0
      },


      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },

      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },


      canEdit() {
        return this.getSelectedItems.length != 0 ;
      },




      noGates(){
          if (this.getSelectedItems.length == 0)
          {
            return false
          }
          var gates = false
          this.getSelectedItems.forEach((it) => {
            if (it.loadKeyWithStageNo == null)
            {
              gates = true
            }
          });
          return !gates;
      },

      canSave() {
        return !!_(this.getEditingItems)
          .find(it => !!this.hasBeenChanged(it));
      },


      canDelete(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        return true


      },

      canDeleteBooking() {
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].deliveryOrder == null)
        {
          return false
        }

        return true
      },


      canDeleteLoad(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        if (this.getSelectedItems[0].loadStatus != "JO")
        {
          return false
        }

        return true


      },



    },

    async mounted() {
      
      this.drivers = [];
      console.log("location")
      console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOCATION'))
      this.$store.dispatch('getUsersByCategory', { category: 'L' })
        .then((res) => {
          this.drivers = res;
  
        });

        this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.$el.querySelector('#expand-button').click();
        const cachedSearchRequest = this.$store.state.yardExportList.searchRequest;
        // if (cachedSearchRequest) {
        //  this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
        // }
        this.$el.querySelector('#searchTag').click();
        this.updateItems(this.getYardExportList);

        
        



    },

     methods: {

       handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },

      sortFunction(sortFiled){
                const nullValues = _.filter(this.items, (item) => {
                  return item[sortFiled] == null
                })
                const values = this.items.filter(it => it[sortFiled] != null);
                const sorted = _.sortBy(values,sortFiled).concat(nullValues);
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
          },



      

      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },

        updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });


          
          this.items = items;
        },


       
       doSearch() {

       
          const {
          users,
          teams,
          salesOffice,
        } = this.searchRequest;
        this.active = false;

        this.searchRequest.chzStartDate.startDate = moment().subtract(2,'months').startOf('d').toDate();
        this.searchRequest.chzStartDate.endDate = moment().add(2,'months').endOf('d').toDate();
        this.$store.dispatch('loadYardExportList', this.searchRequest);
     
       },


      //  async doCopy() {
      //     const request = this.getSelectedItems[0];
      //     if (request.loadKeyWithStageNo == null)
      //     {
      //       alert('There is no stage selected');
      //       return;
      //     }
      //     const data = {
      //       companyOffice: "GST_" + request.salesOffice,
      //       loadKeyWithStageNo: request.loadKeyWithStageNo,
      //       type: request.type || "YY",
      //       loadKey: request.seqNo,
      //       carrier: request.carrier,
      //       action: "COPY",
      //     }

      //     console.log(data);

      //     api.post("/api/w/gst/WebCopyDeleteStage", data)
      //     .then(() => {
      //       this.$store.commit('clearApiError');
      //       this.doSearch();
      //     });

      //  },


      async doDeleteBooking(){
          const request = this.getSelectedItems[0];
          const data = {
            user: 'GST_SYSTEM',
            seqNo: request.seqNo,
            mode: "REMOVE"
          }
          //api.post("/api/w/DOs/WebAssignDoHeaderWithStage", data)
          newAPIPost("/api/w/DOs/WebAssignDoHeaderWithStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
      },


       async doDeleteStage(){
        const request = this.getSelectedItems[0];
          console.log(request);
          const data = {
            companyOffice: "GST_" + request.salesOffice,
            loadKeyWithStageNo: request.loadKeyWithStageNo,
            type: request.type || "YY",
            loadKey: request.seqNo,
            action: "DELETE_STAGE",
          }
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          //api.post("/api/w/gst/WebCopyDeleteStage", data)
          newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });

       },

       async doDeleteLoad(){
        const request = this.getSelectedItems[0];
          console.log(request);
          const data = {
            companyOffice: "GST_" + request.salesOffice,
            loadKeyWithStageNo: request.loadKeyWithStageNo,
            type: request.type || "YY",
            loadKey: request.seqNo,
            action: "DELETE_LOAD",
          }

          //api.post("/api/w/gst/WebCopyDeleteStage", data)
          newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });

       }, 


       doClear(){
        this.filter = "";
        // this.items = this.getYardExportList
        this.updateItems(this.getYardExportList);

       },

       async doChange(){
         
        const request = this.getSelectedItems[0];
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          if (request.stageStatus == 'STC' || request.stageStatus == 'SUC'  )
          {
            alert('The stage has been confirmed or under check, it can not be changed this time!');
            return;
          }

          this.$refs.DispatchFormChange.openDialog(request);

    },


    async doCopy(){
        const request = this.getSelectedItems[0];
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          this.$refs.DispatchFormCopy.openDialog(request);

    },

    handleTypeChanged(id) {
        this.searchRequest.type = id;
      },


    
    handleCarrierChanged(id) {
        this.searchRequest.carrier = id;
      },


    handleDriverRequestChanged(id) {
        this.searchRequest.driver = id;
      },






       handlePickLocationChanged(item) {
        return (pickupLocation) => {
          if (pickupLocation) {
            item.pickupLocationCode = pickupLocation.tagId;
            item.pickUpLocationName = pickupLocation.tagName;
            // item.pickUpLocation = pickupLocation;
          } else {
             //item.pickUpLocationId = null;
            // item.pickUpLocationName = null;
            // item.pickUpLocation = null;
          }
        };
      },



      handleDeliverLocationChanged(item) {
        return (pickupLocation) => {
          if (pickupLocation) {
            item.deliverLocationCode = pickupLocation.tagId;
            item.deliverLocationName = pickupLocation.tagName;
            // item.pickUpLocation = pickupLocation;
          } else {
             //item.pickUpLocationId = null;
            // item.pickUpLocationName = null;
            // item.pickUpLocation = null;
          }
        };
      },


      

      doCockPit() {
        const request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
          console.log(request);
          request.forEach((it) => {
            it.mode = 'YY';
            if (it.loadKey == null)
            {
              it.loadKey = it.seqNo;
            }
          });
          this.$router.push({ 
            name: "cockpit" , 
            params: request})

      },

       async doSave() {
        
      
        const editItem = this.getEditingItems.filter(it  => this.hasBeenChanged(it));
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKeyWithStageNo: it.loadKeyWithStageNo,
            appointment: it.appointment,
            apptDate: dateFormat.getLocalDate(it.apptDate),
            driverId: it.driverId,
            truckId: it.truckId,
            costRelevant: it.costRelevant,
            freightType: it.freightType,
            dispatcherInstruction: it.dispatcherInstruction,
            containerPickupLocation: it.containerPickupLocation,
            containerDropOffLocation: it.containerDropOffLocation,
            offsiteScale: it.offsiteScale,
            seqNo: it.seqNo,
            ccicDropOffLocationCode: it.ccicDropOffLocationCode,
            pickupLocationCode: it.pickupLocationCode,
            pickUpLocationName: it.pickUpLocationName,
            deliverLocationCode: it.deliverLocationCode,
            deliverLocationName: it.deliverLocationName,
            deliveryOrder: it.deliveryOrder,
            
          })).value();
      
        // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
         
         console.log(requests);

         //api.post("/api/w/gst/updateyardstage", requests)
         newAPIPost("/api/w/gst/updateyardstage", requests)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         
      },


      doEdit() {

        const confirmedStage = this.getSelectedItems.filter(it => it.stageStatus == "STC" || it.stageStatus == "SUC")
        if (confirmedStage.length != 0)
        {
           alert("Some stages have been confirmed or under check , it can not be changed at this moment!!");
          return;
        }
        this.getSelectedItems.forEach((it) => {
          it.editing = true;
        });
      },


      async doOutGate(){
          const request = this.getSelectedItems;
          if (request.filter(it => it.stageType == "OUT" || it.stageType == null).length != 0)
          {
            alert("Can not out gate for this item!");
            return 
          }
          const data = request.map(it => ({
            salesOffice: it.salesOffice,
            user: it.user,
            type: it.type,
            appointment: it.appointment,
            apptDate: dateFormat.getLocalDate(it.apptDate),
            pickupDate: dateFormat.getLocalDate(it.pickupDate),
            driverId: it.driverId,
            truckId: it.truckId,
            chassisStartDate :dateFormat.getLocalDate(moment())
          }));


          //await api.post("/api/w/gst/WebYardGroupOutGate", data)
          await newAPIPost("/api/w/gst/WebYardGroupOutGate", data)
          .then(() => {
            this.$store.commit('clearApiError');
            // $('.btn-search-loadlist-container')
            //   .click();
          });
          this.doSearch();

      },






      hasBeenChanged(item) {

        const lhs = _(this.getYardExportList)
          .find(it => it.vueKey === item.vueKey);
        
        if (lhs) {
          return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
            || (lhs.appointment !== item.appointment)
            || (lhs.driverId !== item.driverId)
            || (lhs.truckId !== item.truckId)
            || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
            || (lhs.costRelevant !== item.costRelevant)
            || (lhs.freightType !== item.freightType)
            || (lhs.pickupLocationCode != item.pickupLocationCode)
            || (lhs.deliverLocationCode != item.deliverLocationCode);
        }
        return false;
      },

     handleDriverChanged(item) {
        return (id) => {
          item.driverId = id;
        };
      },






        async CreateIngate(){
            const selectedItem = this.getSelectedItems[0];
            this.$refs.DispatchForm.openDialog(selectedItem);
        //     const req = {
        //       companyOffice: 'GST_' + selectedItem.salesOffice,
        //       loadKey: selectedItem.seqNo,
        //       stageType: 'IN',
        //       stageTypeWithStatus: 'YY'
        //     }
        //  await  api.post("/api/w/gst/createyardstage", req)
        //   .then(() => {
        //     this.$store.commit('clearApiError');
        //     // $('.btn-search-loadlist-container')
        //     //   .click();
        //   });

         // this.doSearch();


           

        },

      toggleCreateIngate(item) {
       
        if (!!_(this.getEditingItems).find(it => !!this.hasBeenChanged(it)))
        {
            alert("Please save stages changes first!!");
          return;
        }

        if (item.bookingNo != null) return 

        //const selectedItem = this.getSelectedItems[0];
        this.$refs.CreateIngate.openDialog(item);

      
      },


      toggleInstruction(item) {

        if (item.editing == false)
        return 

        this.$refs.Instruction.openDialog(item);
      },

        getChassisUsedDate(date){
            return moment().diff(moment(date), 'days')
 
        },



        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
         
          this.active = !this.active;
        },


        getDriverName(item){
            const driver = this.drivers.filter(it => it.id == item);
          
            return  driver.length == 0 ? "" : driver[0].name
        },


      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },


      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },


      includeNull(field){
            return field==null ? '' : field;
        },


      

     },
    }
</script>